import React, { useEffect } from 'react';
import { Card, Col, Divider, Row } from 'antd';
import { HitchConfiguration } from 'components/public/integrations/useHitchConfiguration';
import PreferencesComponent from 'components/private/Preferences';
import Triggers from 'components/private/Triggers';
import { useIntl } from 'react-intl';
import Events from 'components/private/Events';

const TryOut = ({
  hitchConfiguration: { currentHike, onHasPendingChanges, createHike },
  loading,
}: {
  hitchConfiguration: HitchConfiguration;
  loading: boolean;
}): JSX.Element => {
  const { formatMessage } = useIntl();
  useEffect(() => {
    if (!loading && !currentHike) {
      createHike();
    }
  }, [currentHike, loading, createHike]);
  return (
    <Row justify="center" gutter={[32, 32]} style={{ textAlign: 'left' }}>
      <Col xl={18} md={24}>
        <Card bordered>
          <Divider orientation="left">
            <h3>Step 1: Choose your preferences</h3>
          </Divider>
          <p>
            {formatMessage({
              defaultMessage:
                'You are all set! We configured the preferences based on your last sale, and you can start playing around.',
              description: '/onboarding/preferences/intro/1',
            })}
          </p>
          <p>
            {formatMessage({
              defaultMessage:
                'Want to take a closed look? Below you can find and finetune how everything should look in your CRM.',
              description: '/onboarding/preferences/description/1',
            })}
          </p>
          <p>
            {formatMessage({
              defaultMessage:
                'Want to test it first? Scroll deeper and start testing it. You can easily change the preferences afterwards.',
              description: '/onboarding/preferences/description/2',
            })}
          </p>
          {currentHike && (
            <PreferencesComponent hike={currentHike} onHasPendingChanges={onHasPendingChanges} />
          )}
          <Divider orientation="left">
            <h3>Step 2: We hitch, you hike</h3>
          </Divider>
          <p>Happy with the above configuration?</p>
          <p>
            If you want, you can test it out with one of your last sales. With your permission, we
            will create this deal for you.
          </p>
          <Divider orientation="left">Try it out</Divider>
          {currentHike && <Triggers hike={currentHike} limit={10} />}
          <Divider orientation="left">What we did</Divider>
          {currentHike && <Events hikeId={currentHike.id} limit={2} />}
          <Divider />
          <p>
            {formatMessage({
              defaultMessage:
                'Not happy? Change the preferences above, and try again. Or change them later if you want.',
              description: '/onboarding/preferences/description/2',
            })}
          </p>
        </Card>
      </Col>
    </Row>
  );
};

export default TryOut;
